export const Eyebrow = ({ children }) => (
  <span className="font-mono-u text-xs tracking-[0.25em] uppercase text-barber-red">
    {children}
  </span>
);

export const Heading = ({ children, className = "" }) => (
  <h2 className={`font-display text-4xl sm:text-5xl tracking-wide text-cream mt-3 ${className}`}>
    {children}
  </h2>
);
